import { render, staticRenderFns } from "./RelPackageModal.vue?vue&type=template&id=afdfaaf4&"
import script from "./RelPackageModal.vue?vue&type=script&lang=js&"
export * from "./RelPackageModal.vue?vue&type=script&lang=js&"
import style0 from "./RelPackageModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports